'use strict';

var _ = require('lodash');

module.exports = function requireAtLeastOneCheckable(selector, errorContainerSelector, errorClass) {
	errorContainerSelector = errorContainerSelector || '.errorContainer';
	errorClass = errorClass || 'error';

	var error = false;

	var multipleSelectors = selector.split(',');
	_.each(multipleSelectors, function eachSelector(sel) {
		var $sel = window.jQuery(sel);

		if (window.jQuery(sel + ':visible').length === 0) {
			//field his hidden, so it can't be required
			return;
		}

		if ($sel.is('div')) {
			//this is a container, look for inputs inside it
			$sel.each(function () {
				var $this = window.jQuery(this);
				var $inputs = $this.find('input[type=radio],input[type=checkbox]');

				var totalCount = $inputs.length;
				if (totalCount > 0 && $inputs.is(':checked') === false) {
					window.jQuery($inputs[0]).closest(errorContainerSelector).addClass(errorClass);
					error = true;
				} else {
					window.jQuery($inputs[0]).closest(errorContainerSelector).removeClass(errorClass);
				}
			});
		} else {
			//this is an element, assume id/etc instead of .required/etc
			var totalCount = window.jQuery(sel).length;
			if (totalCount > 0 && window.jQuery(sel + ':checked').length === 0) {
				window.jQuery($sel[0]).closest(errorContainerSelector).addClass(errorClass);
				error = true;
			} else {
				window.jQuery($sel[0]).closest(errorContainerSelector).removeClass(errorClass);
			}
		}
	});

	return error;
};
